// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xKPb","rightAdornment":"Header_rightAdornment__1QHG6"};